import { render, staticRenderFns } from "./alliance.vue?vue&type=template&id=5d8ce400&scoped=true"
import script from "./alliance.vue?vue&type=script&lang=js"
export * from "./alliance.vue?vue&type=script&lang=js"
import style0 from "./alliance.vue?vue&type=style&index=0&id=5d8ce400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ce400",
  null
  
)

export default component.exports